import '../../core/components/app-root/AppRoot.css';
import '../../styles/field.css';
import '../../styles/textStyle.css';
import '../spin-buttons/SpinButton.css';
import '../date-time-picker/DateTimePicker.css';
import './DateTimeRangePicker.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var dateTimeInput = '_1vlwkc26-3-12-1';
export var dateTimeRange = _7a468({defaultClassName:'_1vlwkc20-3-12-1',variantClassNames:{showError:{true:'_1vlwkc21-3-12-1'},disabled:{true:'_1vlwkc22-3-12-1'},readOnly:{true:'_1vlwkc23-3-12-1'}},defaultVariants:{},compoundVariants:[[{showError:true,readOnly:true},'_1vlwkc24-3-12-1']]});
export var scrollContainer = '_1vlwkc25-3-12-1';
export var timeframeSeparator = '_1vlwkc27-3-12-1';